import React from "react";
import styled from "styled-components";

export default ({ children }) => {
  return <ContentsBodyDiv>{children}</ContentsBodyDiv>;
};

const ContentsBodyDiv = styled.div`
  display: flex;
  padding: 40px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;

  color: #333;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px; /* 133.333% */
`;
